import React from 'react'

function Concierge() {
  return (
    <div>Concierge</div>
  )
}

export default Concierge